import CircularProgress from "components/circular-progress";
import { Document } from "react-pdf";
import { neutral } from "app/themes/colors";
import Box from "@mui/material/Box";
import React from "react";
import PdfDocumentPages from "./pdf-document-pages.component";
import { isEqual } from "lodash";

const containerSx = {
  display: "flex",
  overflow: "auto",
  justifyContent: "center",
  minHeight: "700px",
  background: neutral[800],
};

interface PdfDocumentContainerProps {
  pdfBlobUrl: string | undefined;
  numPages: number | null;
  isReady?: boolean;
  pdfContainerRef: React.RefObject<HTMLDivElement>;
}

const PdfDocumentContainer = ({
  numPages,
  pdfBlobUrl,
  isReady,
  pdfContainerRef,
}: PdfDocumentContainerProps) => {
  return (
    <Box ref={pdfContainerRef} width="100%" height="100%" sx={containerSx}>
      {!isReady || !pdfBlobUrl || !numPages ? (
        <CircularProgress />
      ) : (
        <Document file={pdfBlobUrl} className="pdf-document">
          <PdfDocumentPages numPages={numPages} />
        </Document>
      )}
    </Box>
  );
};

export default React.memo(PdfDocumentContainer, (prevProps, nextProps) => {
  return isEqual(prevProps, nextProps);
});
